exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".edit-container[data-v-3cdc509b]{width:100%;height:100%;display:-webkit-box;display:-ms-flexbox;display:flex}.edit-container .left-side[data-v-3cdc509b]{width:350px;padding:10px 10px 0px 10px;background:#eeeeee}.edit-container .left-side .left-side-top[data-v-3cdc509b]{height:30px}.edit-container .left-side .left-side-main[data-v-3cdc509b]{height:80vh;overflow:auto}.edit-container .right-side[data-v-3cdc509b]{padding:20px 0px 0px 20px}\n", ""]);

// exports
